var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.08,
    d: "M-652-288H788V736H-652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M465-287V736h-793V-287z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    fillRule: "nonzero",
    d: "M9.667 9.667a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666m0 1.666C7.442 11.333 3 12.45 3 14.667v1.666h13.333v-1.666c0-2.217-4.441-3.334-6.666-3.334"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e4fd85c858029b7edaa5ba8e771799a9.svg";
export { ForwardRef as ReactComponent };